import { combineReducers } from 'redux';

import { IEntityActions } from '../../../../data/store';
import { Actions as ContractActions, ActionTypes as ContractActionTypes } from '../../../../entities/contracts/actions';
import { SaveState } from '../../../../types';
import { Actions, ActionTypes } from '../actions';
import { IMarketingPreferences } from './types';

export const drafts = (state = {} as { [id: string]: IMarketingPreferences }, action: Actions | ContractActions | IEntityActions = {} as any) => {
	switch (action.type) {
		case ActionTypes.UI_CHANGED:
			return {
				...state,
				[action.payload.id]: action.payload.marketingPreferences
			};
		case ContractActionTypes.CUSTOMER_CONTRACTS_RECEIVE:
		case ContractActionTypes.UPDATE_CONTRACTS_RECEIVE:
			const markPrefsCont = state[action.payload.id] || {} as IMarketingPreferences;
			markPrefsCont.contracts = action.payload.contracts;
			return {
				...state,
				[action.payload.id]: markPrefsCont
			};
		case 'CANCELLATION_PREFERENCE_BY_CUSTOMER_RECEIVE':
			const markPrefsCustCanc = state[action.payload.customer] || {} as IMarketingPreferences;
			markPrefsCustCanc.cancellationPolicy = action.payload.cancellationPreference.tn_cancellation_preference;
			return {
				...state,
				[action.payload.customer]: markPrefsCustCanc
			};
		case 'CANCELLATION_PREFERENCE_UPDATE_BY_RECIPIENT_RECEIVE':
			const markPrefsCanc = state[action.payload.recipient] || {} as IMarketingPreferences;
			markPrefsCanc.cancellationPolicy = action.payload.cancellationPreference.tn_cancellation_preference;
			return {
				...state,
				[action.payload.recipient]: markPrefsCanc
			};
		default:
			return state;
	}
};

export const loading = (state = false, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.GET_MARKETING_PREFERENCES_REQUEST:
			return true;
		case ActionTypes.GET_MARKETING_PREFERENCES_RECEIVE:
		case ActionTypes.GET_MARKETING_PREFERENCES_FAILURE:
			return false;
		default:
			return state;
	}
};

export const saving = (state = false, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.UPDATE_MARKETING_PREFERENCES_REQUEST:
			return true;
		case ActionTypes.UPDATE_MARKETING_PREFERENCES_RECEIVE:
		case ActionTypes.UPDATE_MARKETING_PREFERENCES_FAILURE:
			return false;
		default:
			return state;
	}
};

export interface ISaveState {
	cancellationPreference: SaveState;
	contract: SaveState;
}

export const defaultSaveState = {
	cancellationPreference: SaveState.NONE,
	contract: SaveState.NONE
};

export const saveState = (state = defaultSaveState, actions: ContractActions | IEntityActions = {} as any) => {
	switch (actions.type) {
		case 'CANCELLATION_PREFERENCE_UPDATE_BY_RECIPIENT_RECEIVE':
			return { ...state, cancellationPreference: SaveState.SUCCESS };
		case ContractActionTypes.UPDATE_CONTRACTS_RECEIVE:
			return { ...state, contract: 'success' };
		case 'CANCELLATION_PREFERENCE_UPDATE_BY_RECIPIENT_FAILURE':
			return { ...state, cancellationPreference: SaveState.FAILURE };
		case ContractActionTypes.UPDATE_CONTRACTS_FAILURE:
			return { ...state, contract: SaveState.FAILURE };
		default:
			return state;
	}
};

export const touched = (state = false, actions: Actions = {} as any) => {
	switch (actions.type) {
		case ActionTypes.UI_CHANGED:
			return true;
		case ActionTypes.UPDATE_MARKETING_PREFERENCES_RECEIVE:
		case ActionTypes.UPDATE_MARKETING_PREFERENCES_FAILURE:
			return false;
		default:
			return state;
	}
};

export interface ICustomerPageState {
	drafts: ReturnType<typeof drafts>;
	loading: ReturnType<typeof loading>;
	saving: ReturnType<typeof saving>;
	saveState: ReturnType<typeof saveState>;
	touched: ReturnType<typeof touched>;
}

export default combineReducers<ICustomerPageState>({
	drafts,
	loading,
	saving,
	saveState,
	touched
});
